import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './Dialog.module.scss';
import classNames from 'classnames';
import ModalDialog from './ModalDialog';
import {playAudio} from './mediaBundle';

export default class Dialog extends Component {
    static propTypes = {
        visible: PropTypes.bool,
        className: PropTypes.string,
        renderIcon: PropTypes.func.isRequired,
        okButtonLabel: PropTypes.string.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    render() {
        const {visible, renderIcon, okButtonLabel, onClose, children} = this.props;

        const dialogClassName = classNames(styles.dialog, this.props.className, {
            [styles.dialogVisibled]: visible,
        });

        return (
            <ModalDialog visible={visible}>
                <div className={styles.iconAnchor}>{renderIcon()}</div>
                <div className={dialogClassName}>
                    <div className={styles.content}>{children}</div>
                    <button
                        className={styles.button}
                        onClick={() => {
                            playAudio('button');
                            onClose();
                        }}
                    >
                        {okButtonLabel}
                    </button>
                </div>
            </ModalDialog>
        );
    }
}
